import ProductAjaxService from "./ProductAjaxService";

export default class CompareActions extends ProductAjaxService {
    constructor() {
        super();
        this.addToCompare();
        this.deleteProduct();
        this.deleteCategory();
    }

    getCompare() {
        this._GET(this.getCompareUrl, this.updateSmallCarts);
    }

    addToCompare() {
        let self = this;
        $(document).on('click', '.add_to_compare', function (e) {
            e.preventDefault();
            if($(this).hasClass('active')) return true;

            let ID = $(this).attr('data-id');
            if(!ID) {
                console.warn('Please set product ID');
                return false;
            }

            self._POST(self.addToCompareUrl, {product_id: ID}, self.updateSmallCarts);

            let $compItem = $('.add_to_compare[data-id='+ ID +']');
            $compItem.addClass('active');
        });
    }
    deleteProduct() {
        let self = this;
        $(document).on('click', '.delete_compare_item', function (e) {
            e.preventDefault();
            if($(this).hasClass('active')) return true;

            let ID = $(this).attr('data-id'),
                category_id = $(this).attr('data-cat');
            if(!ID) {
                console.warn('Please set product ID');
                return false;
            }

            self._POST(self.deleteItemURL, {product_id: ID, category_id: category_id}, self.updateSmallCarts);

            let $compItem = $('.add_to_compare[data-id='+ ID +']');
            $compItem.removeClass('active');
        });
    }
    deleteCategory() {
        let self = this;
        $(document).on('click', '.delete_compare_category', function (e) {

            e.preventDefault();
            let ID = $(this).attr('data-id'),
                confName = 'confirm:delete';
            if(!ID) {
                console.warn('Please set product ID');
            }

            let headerCart = $(this).closest('#compare_desktop, .compare_slide').length;

            //Confirm delete
            if(headerCart) {
                self._POST(self.deleteCatURL, {category_id: ID}, self.updateSmallCarts);
            } else {
                $(document).bind(confName, function () {
                    $(document).unbind(confName);
                    self._POST(self.deleteCatURL, {category_id: ID}, self.updateSmallCarts);
                });
            }

            if(!headerCart) {
                self.confirmDelete(confName, true);
            }
        });
    }

    updateSmallCarts(res) {
        if(res.success) {
            if(res.data.html_big) {
                $('#xhr-compare-content').html(res.data.html_big);
            }

            if(res.data.html) {
                if($(window).width() >= 1200) {
                    if($('.ajax_small_items_compare.scroll-content').length) {
                        $('.ajax_small_items_compare.scroll-content').html(res.data.html);
                    } else {
                        $('.ajax_small_items_compare').html(res.data.html);

                        //Custom scroll
                        $('.ajax_small_items_compare').scrollbar();
                    }
                } else {
                    $('.ajax_small_items_compare').html(res.data.html);
                }

                $('.open_swipe[data-swipe="#compare_slide"] span strong').html(res.data.count);

                $('.ajax_content_compare_true').show();
                $('.ajax_content_compare_false').hide();

                $('.hover_item .compare_icon, .open_swipe .icon-equalizer')
                    .parent().addClass('icon_indicator');
            } else {
                $('.ajax_small_items_compare').html('');
                $('.open_swipe[data-swipe="#compare_slide"] span strong').html('');

                $('.ajax_content_compare_true').hide();
                $('.ajax_content_compare_false').show();

                $('.hover_item .compare_icon, .open_swipe .icon-equalizer')
                    .parent().removeClass('icon_indicator');
            }

            $(document).trigger('refresh.compare.page');
            if(res.data.product_ids) {
                for (let property in res.data.product_ids) {
                    $('.add_to_compare[data-id='+ res.data.product_ids[property] +']').removeClass('active');
                }
            }
        }
    }
}
